import { settingsService } from '../_services';

const getDefaultState = () => {
  return {
    current: {}
  }
}

export const settings = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
        commit('resetState')
    },
    getSettings({ commit }, clientId) {
      commit('getSettingsRequest');
      settingsService.getSettings(clientId)
        .then(
          company => commit('getSettingsSuccess', company),
          error => commit('getSettingsFailure', error)
        );
    },
    updateSettings({ commit }, params) {
      commit('updateSettingsRequest');
      settingsService.updateSettings(params)
        .then(
          client => commit('updateSettingsSuccess', client),
          error => commit('updateSettingsFailure', error)
        );
    }
  },
  mutations: {
    resetState (state) {
        Object.assign(state, getDefaultState())
    },
    getSettingsRequest(state) {
      state.current = { loading: true };
    },
    getSettingsSuccess(state, settings) {
      state.current = settings;
    },
    getSettingsFailure(state, error) {
      state.current = { error };
    },

    updateSettingsRequest(state) {
      state.current = { loading: true };
    },
    updateSettingsSuccess(state, client) {
      state.current = client;
    },
    updateSettingsFailure(state, error) {
      state.current = { error };
    },


  }
}